var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50033 2.12848L14.0516 10.3432C14.6224 10.7383 15.3783 10.7383 15.949 10.3432L27.5003 2.12848M5.00033 21H25.0003C26.8413 21 28.3337 19.5076 28.3337 17.6667V4.33333C28.3337 2.49238 26.8413 1 25.0003 1H5.00033C3.15938 1 1.66699 2.49238 1.66699 4.33333V17.6667C1.66699 19.5076 3.15938 21 5.00033 21Z",
    stroke: "#FF9240",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.2455a3dfaf7f46b163e94abb1da3f5ae.svg";
export { ForwardRef as ReactComponent };